import { render } from "./UploadPop.vue?vue&type=template&id=c8cf79d0"
import script from "./UploadPop.vue?vue&type=script&lang=js"
export * from "./UploadPop.vue?vue&type=script&lang=js"

import "./UploadPop.vue?vue&type=style&index=0&id=c8cf79d0&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__